<template>
  <el-card shadow="hover" style="padding: 10px">
    <div class="page-title">
      <span>失败原因</span>
    </div>
    <div style="min-height: 100px">
      {{ pageParams.failureMsg || "暂无内容" }}
    </div>
  </el-card>
</template>

<style lang="less" scoped>
.page-title {
  color: #919191;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
}
</script>